import { emitSearchAssetsEvent } from '../helpers/emitSearchAssetsEvent';
import { emitSimilaritySearchEvent } from '../NLSSearch/utils';

export function removeSingleTextFilter() {
	const filter = {
		disableModal: false,
		field: 'singletext',
		filterType: 'remove',
		value: '', // The searchTerm (aka value) is NOT needed. Sticky search (aka singletext search) only allows for one search term being applied at a time, so any request to 'remove' removes whichever was applied (if any)
	};

	emitSearchAssetsEvent(filter);
}

export function resetSimilarityFilters() {
	const skipAddingToFilterbar = true;

	// We emit an event and AssetOverview in paramount handles the searching and removing from filterbar
	emitSimilaritySearchEvent(
		{
			similarToAssetIds: null,
			similarToImageData: null,
			similarToURL: null,
			similarToText: null,
		},
		skipAddingToFilterbar,
	);
}
